export enum AddressKeys {
  addressId = 'addressId',
  addressTypeId = 'addressTypeId',
  street = 'street',
  street2 = 'street2',
  city = 'city',
  stateId = 'stateId',
  zipcode = 'zipcode',
  latitude = 'latitude',
  longitude = 'longitude',
  primary = 'primary'
}

export interface IAddress {
  readonly [AddressKeys.addressId]: number;
  [AddressKeys.addressTypeId]: number;
  [AddressKeys.street]: string;
  [AddressKeys.street2]: string | null;
  [AddressKeys.city]: string;
  [AddressKeys.stateId]: number;
  [AddressKeys.zipcode]: string;
  latitude?: number;
  longitude?: number;
  [AddressKeys.primary]: boolean;
  axRecId?: number | null;
}
